module.exports = __webpack_public_path__ + "img/svg/banner-card-mobile.b677becd3b18bf0e7d3489ab8460fbcb.svg";